import React from 'react';
import { bool, func, object, string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { LISTING_STATE_DRAFT } from '../../util/types';
import { ListingLink } from '..';
import { EditListingCoachingAccreditationsForm } from '../../forms';

import css from './EditListingCoachingAccreditationsPanel.module.css';
import { convertKeywordToSearch } from '../../util/search';
import config from '../../config';

const EditListingCoachingAccreditationsPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { publicData : { coachingAccreditations, coachingAccreditationsOther } } = currentListing?.attributes || {};
  const { filters } = config.custom;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingCoachingAccreditationsPanel.title"
      values={{
        listingTitle: (
          <ListingLink listing={listing}>
            <FormattedMessage id="EditListingCoachingAccreditationsPanel.listingTitle" />
          </ListingLink>
        ),
      }}
    />
  ) : (
    <FormattedMessage id="EditListingCoachingAccreditationsPanel.createListingTitle" />
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingCoachingAccreditationsForm
        className={css.form}
        initialValues={{ coachingAccreditations, coachingAccreditationsOther }}
        saveActionMsg={submitButtonText}
        onSubmit={values => {
          const { coachingAccreditations, coachingAccreditationsOther } = values;
          const updateValues = {
            publicData: {
              coachingAccreditations,
              coachingAccreditationsOther,
              coachingAccreditationsToSearch: convertKeywordToSearch({
                filterId: 'coachingAccreditations',
                filters,
                keyList: coachingAccreditations,
                keyOther: coachingAccreditationsOther
              })
            },
          };

          onSubmit(updateValues);
        }}
        onChange={onChange}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingCoachingAccreditationsPanel.defaultProps = {
  className: null,
  rootClassName: null,
  errors: null,
  listing: null,
};

EditListingCoachingAccreditationsPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingCoachingAccreditationsPanel;
